import React, {useState} from 'react';
import Img from "react-image";
import useAvatar from "../../../shared/hooks/useAvatar";
import PropTypes from "prop-types";


type AvatarProp = {
    value: string,
    onChange: PropTypes.func,
    name: string,
}


const Avatar = (props: AvatarProp) => {
    const [value, setValue] = useState(props.value || 0);
    let fileInput = null;

    const handleUpload = () => {
        fileInput.click();
    };

    const handleChange = e => {
        const file = e.target.files[0];
        const data = file['type'].split('/')[0] === 'image' ? URL.createObjectURL(file) : null;
        setValue(data);
        props.onChange(props.name, e.target.files);
    };

    return (
        <React.Fragment>
            <div className='text-center'>
                <Img src={value ? value : useAvatar({
                    full_name: props.username,
                })}
                     className='profile-thumbnail rounded-circle cursor-pointer' width={160} height={160}
                     onClick={handleUpload}
                />
            </div>
            <input type="file" hidden
                   onChange={handleChange}
                   accept="image/*"
                   name={props.name}
                   ref={input => fileInput = input}
            />
        </React.Fragment>
    )
};


export default Avatar;
